import { __read, __spreadArray } from "tslib";
import React, { useEffect, useMemo, useState } from 'react';
import { BrandedRevealImage } from './BrandedRevealImage';
import { productListSilhouetteSrc } from '../images/productSilhouette';
/**
 * Branded lazy-load shell for product grid images (Molo logo mask + shimmer).
 * On CDN 404, tries fallbackSrcs then shows a neutral silhouette placeholder.
 */
export var ProductListImage = function (_a) {
    var src = _a.src, alt = _a.alt, scrollPosition = _a.scrollPosition, _b = _a.threshold, threshold = _b === void 0 ? 300 : _b, _c = _a.visibleByDefault, visibleByDefault = _c === void 0 ? false : _c, onLoad = _a.onLoad, _d = _a.fallbackSrcs, fallbackSrcs = _d === void 0 ? [] : _d;
    var candidates = useMemo(function () {
        var list = __spreadArray(__spreadArray([src], __read(fallbackSrcs), false), [productListSilhouetteSrc], false);
        var seen = new Set();
        return list.filter(function (url) {
            if (!url || seen.has(url)) {
                return false;
            }
            seen.add(url);
            return true;
        });
    }, [src, fallbackSrcs]);
    var _e = __read(useState(0), 2), index = _e[0], setIndex = _e[1];
    var candidatesKey = useMemo(function () { return candidates.join('\0'); }, [candidates]);
    useEffect(function () {
        setIndex(0);
    }, [candidatesKey]);
    var currentSrc = candidates[Math.min(index, candidates.length - 1)] || productListSilhouetteSrc;
    var isSilhouette = currentSrc === productListSilhouetteSrc;
    var handleError = function () {
        setIndex(function (prev) {
            if (prev + 1 < candidates.length) {
                return prev + 1;
            }
            return prev;
        });
    };
    return (React.createElement(BrandedRevealImage, { key: currentSrc, src: currentSrc, alt: alt, variant: "list", lazy: !isSilhouette, scrollPosition: scrollPosition, threshold: threshold, visibleByDefault: visibleByDefault || isSilhouette, onLoad: onLoad, onError: handleError, imageClassName: "pl-item__image pl-item__product-image" }));
};
export default ProductListImage;
//# sourceMappingURL=ProductListImage.js.map